import { Text, Tooltip } from '@shopify/polaris';
import { memo } from 'react';

interface TextTooltipProps {
  str: string;
  trimLength?: number;
}
const TextTooltip = memo(({ str, trimLength = 15 }: TextTooltipProps) => {
  return (
    <>
      {str.length > trimLength ? (
        <Tooltip dismissOnMouseOut content={str}>
          <Text as="span">{str.slice(0, trimLength)}...</Text>
        </Tooltip>
      ) : (
        str
      )}
    </>
  );
});

export default TextTooltip;
